import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { rescueHtml } from '../Components/Tools.js';


const Page1Accueil = (props) =>
{
    const blue = '#069BD3'

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            
            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    {props.logoOrganisme && (
                        <img style={props.logoOrganisme !== null?{maxHeight: 200, borderRadius: 5}:{}} src={props.logoOrganisme} />
                    )}
                </div>

                <div style={{flex: 1}}></div>
            </div>


            {/* Container */}
            <div style={{flex: 1, marginTop: 0}}>
                <div style={{height: '10%'}}></div>
                <div style={{textAlign: 'center'}}>
                    <p style={{fontSize: 30}}>{rescueHtml(props.user.nom_organisme)}</p>
                    <p style={{fontSize: 20}}>{rescueHtml(props.user.nom_budget)}</p>
                    <p style={{fontSize: 20, color: blue, marginTop: 20}}>Bilan budgétaire et financier / Mise en perspective des équilibres budgétaires</p>
                </div>

                <div style={{display: 'flex', marginTop: 50}}>
                    <div style={{flex: 1}}></div>
                    <div style={{flex: 1, textAlign: 'center'}}>
                        <p style={{fontSize: 14, fontFamily: 'Times-Italic'}}>Dernier compte connu : {props.yearsRetro.slice(-1)}</p>
                    </div>
                    <div style={{flex: 1}}></div>
                </div>

                <div style={{display: 'flex', marginTop: 150}}>
                    <div style={{flex: 1}}></div>
                    <div style={{flex: 2, textAlign: 'right', display: 'flex', justifyContent: 'right'}}>
                        <img style={{width: 300}} src={Logo} />
                    </div>
                    <div style={{flex: 0.2}}></div>
                </div>
            </div>


            
            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
            </div>
        </div>
    );
}
  
  export default Page1Accueil;